import { useContext } from "react";

import { DispatchContext, DispatchPropertiesTabs, PropertiesTabsState, StateContext } from "./reducer";

export function usePropertiesTabs(): PropertiesTabsState {
    const context = useContext(StateContext);
    if (context === undefined) {
        throw new Error("usePropertiesTabs must be used within a PropertiesTabsProvider");
    }
    return context;
}

export function useDispatchPropertiesTabs(): DispatchPropertiesTabs {
    const context = useContext(DispatchContext);
    if (context === undefined) {
        throw new Error("useDispatchPropertiesTabs must be used within a PropertiesTabsProvider");
    }
    return context;
}
